import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, BadgeCheck } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { api, formatError, TIER_RANK } from "../lib/api";
import { ChatThread } from "../components/ChatThread";

export default function Messages() {
  const { user } = useAuth();
  const allowed = TIER_RANK[user.tier] >= 1;
  const [messages, setMessages] = useState([]);

  const load = useCallback(() => {
    api.get("/messages").then((r) => setMessages(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (!allowed) return undefined;
    load();
    const t = setInterval(load, 6000);
    return () => clearInterval(t);
  }, [allowed, load]);

  const send = async (text) => {
    try {
      const { data } = await api.post("/messages", { text });
      setMessages((m) => [...m, data]);
      return true;
    } catch (e) {
      toast.error(formatError(e));
      return false;
    }
  };

  return (
    <main data-testid="messages-page" className="max-w-[900px] mx-auto px-4 sm:px-8 pt-[110px] pb-12">
      <div className="border border-[#0E1B3D]/[0.08] bg-[#FFFFFF] h-[calc(100svh-170px)] min-h-[480px] flex flex-col">
        <header className="flex items-center gap-3 px-5 py-4 border-b border-[#0E1B3D]/[0.08]">
          <img src="/img/avatar.jpg" alt="Katie" className="w-11 h-11 rounded-full object-cover ring-1 ring-[#D7263D]/50" />
          <div>
            <p className="font-display text-xl text-[#0E1B3D] flex items-center gap-1.5">Katie Razenski <BadgeCheck className="w-4 h-4 text-[#D7263D]" /></p>
            <p className="text-xs text-[#4A5878]">Private conversation</p>
          </div>
        </header>
        {allowed ? (
          <ChatThread messages={messages} mine="fan" onSend={send} placeholder="Message Katie…" />
        ) : (
          <div data-testid="dm-locked-state" className="flex-1 flex flex-col items-center justify-center text-center px-6 gap-5">
            <span className="w-16 h-16 rounded-full border border-[#D7263D]/60 grid place-items-center"><Lock className="w-6 h-6 text-[#D7263D]" /></span>
            <h1 className="font-display text-3xl text-[#0E1B3D]">Direct messages are for VIP & Inner Circle</h1>
            <p className="text-sm text-[#4A5878] max-w-sm">Upgrade your membership to open a private line to Katie.</p>
            <Link to="/join?tier=vip" data-testid="dm-upgrade-btn" className="gold-btn px-7 py-3.5 text-xs font-semibold tracking-[0.16em] uppercase">Upgrade to VIP</Link>
          </div>
        )}
      </div>
    </main>
  );
}
